import { Injectable } from '@angular/core';
import { BaseService } from '@app/shared/services/base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomerSearchInput } from '@app/core/models/customer-search-input.model';
import { Customer } from '@app/core/models/customer.model';

// The client tracks the search type as a number (legacy ECustomerSearchType
// values); the NestJS API expects the string name.
const SEARCH_TYPE_NAMES: Record<number, string> = {
  1: 'Name',
  2: 'Company',
  3: 'City',
  4: 'Address',
  5: 'PhoneNumber',
};

@Injectable({
  providedIn: 'root',
})
export class CustomerService extends BaseService {
  constructor(protected http: HttpClient) {
    super('customers', http);
  }

  searchCustomers(searchInput: CustomerSearchInput): Observable<Customer[]> {
    const params = new HttpParams()
      .set('term', searchInput.term.trim())
      .set('type', SEARCH_TYPE_NAMES[searchInput.searchType] ?? 'Name');
    return this.http.get<Customer[]>(`${this.resourceUrl}/search`, { params });
  }
}
